export enum ForkJobPurpose {
    Repacking = 'Repacking',
    Reprocessing = 'Reprocessing',
    Dispatch = 'Dispatch',
    Repallating = 'Repallating',
    Processing = 'Processing',
}